import React from 'react';
import { Form } from 'react-bootstrap';
import { FormSelect, FormNumber } from '~/components/FormControl';
import { GIVEN_TYPE_OPTIONS } from '~/config/constants';

function TypeDetail() {
    return (
        <>
            <Form.Row>
                <FormSelect
                    name="typeDetail.givenTypeOption"
                    options={GIVEN_TYPE_OPTIONS || []}
                    sm={3}
                    tooltip="Give either points or hp for an effect. Ex: Campfire."
                />
                <FormNumber
                    name="typeDetail.givenTypeValue"
                    min={0}
                    max={12}
                    sm={3}
                    tooltip="Set a number of points or hp for an effect. Ex: Campfire."
                />
                <FormSelect
                    name="typeDetail.receivedTypeOption"
                    options={GIVEN_TYPE_OPTIONS || []}
                    sm={3}
                    tooltip="Receive either points or hp for an effect. Ex: Campfire."
                />
                <FormNumber
                    name="typeDetail.receivedTypeValue"
                    min={0}
                    max={12}
                    sm={3}
                    tooltip="Set a number of points or hp for an effect. Ex: Campfire."
                />
            </Form.Row>

            <Form.Row>
                <FormSelect
                    name="typeDetail.bidTypeOption"
                    options={GIVEN_TYPE_OPTIONS || []}
                    sm={3}
                    tooltip="Set bidding to give points or hp. Ex: Bounty Hunter."
                />
            </Form.Row>
        </>
    );
}

export default TypeDetail;
